exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-3c9aadad],.fade-leave-active[data-v-3c9aadad]{transition:opacity .2s}.fade-enter[data-v-3c9aadad],.fade-leave-to[data-v-3c9aadad]{opacity:0}", ""]);

// exports
